export const setUrl = (url: string): string => {
    const lien = import.meta.env.VITE_API_URL;
    return new URL(url, lien).href;
};

export const setUrlWithParams = (baseUrl: string, params: Record<string, string | string[]>): string => {
    const url = new URL(baseUrl, import.meta.env.VITE_API_URL);

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((val) => url.searchParams.append(key, val));
        } else {
            url.searchParams.append(key, value);
        }
    });

    return url.href;
};